import { useQueryClient } from '@tanstack/react-query';
import { useMutateConversationCache } from './cache';
import { conversationKeys } from './queryKeys';

export function useOptimisticMuteConversation() {
  const queryClient = useQueryClient();
  const { mutateConversationCache } = useMutateConversationCache();

  async function optimisticMuteConversation(queryKey: ReturnType<typeof conversationKeys.conversation>, mute: boolean) {
    const conversationCacheData = await mutateConversationCache(queryKey, (cacheConversation) => ({
      ...cacheConversation,
      muted: mute,
    }));

    return conversationCacheData;
  }

  async function optimisticMuteConversationError(context?: Awaited<ReturnType<typeof optimisticMuteConversation>>) {
    if (context) {
      queryClient.setQueryData(context?.conversationKey, context?.previousConversationState);
    }
  }

  async function optimisticMuteConversationSuccess(context?: Awaited<ReturnType<typeof optimisticMuteConversation>>) {
    if (context) {
      await queryClient.invalidateQueries(context?.conversationKey);
    }
  }

  return {
    optimisticMuteConversation,
    optimisticMuteConversationError,
    optimisticMuteConversationSuccess,
  };
}
